export const LANDING = '/';
export const LANDING_BETA = '/beta';
export const HELP = '/help';
export const PRICING = '/pricing';

